/**
 * @fileoverview GET handler for the "/:app_group_id/conversational/tool_definitions" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { conversationalToolDefinitions } from "./constants";
import type { ConversationalToolDefinitionsParams, ConversationalToolDefinitionsResult } from "./types";
import { isConversationalToolDefinitionsResult } from "./validators";

export const getDataTableConversationalToolDefinitions = reactQueryTableFetcherAdapter(
  conversationalToolDefinitions,
  (
    signal: AbortSignal,
    { appGroupId, type, searchQuery, dataType, limit, start, sortdir }: ConversationalToolDefinitionsParams
  ): Promise<ConversationalToolDefinitionsResult> => {
    return fetch(
      `/${appGroupId}/conversational/tool_definitions`,
      "GET",
      {
        type,
        limit,
        sortdir,
        start,
        search_term: searchQuery,
        data_type: dataType,
      },
      { signal }
    );
  },
  isConversationalToolDefinitionsResult
);
